interface WithdrawDisplayRecord {
  amount?: number | string | null;
  finalAmount?: number | string | null;
  paymentName?: unknown;
  settledAmount?: number | string | null;
  status?: string;
}

const P2PAY_PAYMENT_NAME = "P2PAY";

function toComparableMinorAmount(value: unknown): number | null {
  if (typeof value === "number") {
    return Number.isSafeInteger(value) && value >= 0 ? value : null;
  }

  if (typeof value !== "string" || !/^(0|[1-9][0-9]*)$/.test(value)) {
    return null;
  }

  const amount = Number(value);
  return Number.isSafeInteger(amount) ? amount : null;
}

export function isP2PayWithdraw(paymentName: unknown): boolean {
  return typeof paymentName === "string" && paymentName.toUpperCase() === P2PAY_PAYMENT_NAME;
}

export function getWithdrawDisplayAmount(record: WithdrawDisplayRecord): number | string | null | undefined {
  if (!isP2PayWithdraw(record.paymentName)) return record.amount;

  return record.settledAmount ?? 0;
}

export function getWithdrawDisplayFinalAmount(record: WithdrawDisplayRecord): number | string | null {
  if (!isP2PayWithdraw(record.paymentName)) {
    // Preserve the existing non-P2PAY rendering, where numeric zero is unavailable.
    return record.finalAmount ? record.finalAmount : null;
  }

  if (record.status !== "COMPLETED") return null;

  return record.settledAmount ?? null;
}

export function getWithdrawDisplayStatus(record: WithdrawDisplayRecord): string | undefined {
  if (!isP2PayWithdraw(record.paymentName) || record.status !== "COMPLETED") {
    return record.status;
  }

  const requestedAmount = toComparableMinorAmount(record.amount);
  const settledAmount = toComparableMinorAmount(record.settledAmount);

  if (
    requestedAmount !== null &&
    settledAmount !== null &&
    settledAmount > 0 &&
    settledAmount < requestedAmount
  ) {
    return "PARTIALLY COMPLETED";
  }

  return record.status;
}
